// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "modules/" + {"2342":"CovidStateRow","2685":"CovidCovidRecirc","3385":"CovidCovidTotalsTable","5483":"CovidCovidInfo","6137":"CovidCountryRow","7742":"CovidCovidUsaTotalsTable","8067":"CovidCovidHp"}[chunkId] + "_module.js?v=" + __webpack_require__.h().slice(0, 8) + "";
};